module.exports = __webpack_public_path__ + "img/mz.1d92e04d.svg";